export default {
  id: "beyond-books-dragon-dance",
  pride: 44032,
  slug: "beyond-books-dragon-dance",
  series: "beyond-books",
  category: "novel",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "不止于纸上的故事：舞龙篇",
    en: "Beyond Books: Dragon Dance"
  },
  image: require('@/assets/images/bbdd.webp'),
  descriptionKey: {
    zh: "完成稿，五方异能者会战，力量与选择主题。",
    en: "Completed novel. A five-way esper battle, themed around power and choice."
  },
  date: { year: 2024, month: 1 },
  genres: ["超能力智斗", "都市奇幻"],
  themes: ["力量与选择", "五方会战"],
  scale: {
    zh: "完成稿",
    en: "Completed manuscript"
  },
  developerNotesKey: {
    zh: "小说的读者都是个位数。发布在微信公众号，个人博客。这是主要的世界观核心作品。",
    en: "The novel has single-digit readers. Published on WeChat Official Account and personal blog. This is a core worldview work."
  },
  tags: ["小说"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "blog", url: "https://tobenot.top/p/story-bb-dragon-dance/", textKey: { zh: "博客阅读", en: "Read on Blog" } }
  ]
};
